// Case Buddy domain module generated from CaseBuddyCore.js.
// Spreadsheet-shaped rows remain the source of truth.
export const PROJECT_FILES_INDEX_KEY = 'tool60_spreadsheet_files_index_v1';

export const PROJECT_WORKBOOK_VERSION = 1;

export const LEGACY_INPUT_WORKBOOK_KEY = 'tool60_input_workbook_state_v4';

export const LEGACY_SINGLE_SHEET_KEY = 'tool60_state';

export const DEFAULT_AUTH_SESSION = Object.freeze({
  isAuthenticated: false,
  role: null,
  token: '',
  accessToken: '',
  jwt: '',
  canUseNormalMode: false,
  canUseAllTools: false,
  canUseCaseBuddy: false,
  canUseHermesPage: false,
  isAgentAccount: false,
  agentAccessEnabled: false
});

export const CASE_BUDDY_NETWORK_LOOKUP_ENDPOINT = '/api/etherscan/workflow/lookup_transaction_network_casebuddy_web.php';

export const CASE_BUDDY_ARKHAM_NOTE_ENRICHMENT_ENDPOINT = '/api/arkham/arkham_note_enrichment_batch.php';

export const CASE_BUDDY_NETWORK_LOOKUP_DELAY_MS = 450;

export const WORKFLOW_SIGNAL_TRANSACTION_NETWORKS_IDENTIFIED = 'TRANSACTION_NETWORKS_IDENTIFIED';

export const WORKFLOW_SIGNAL_TRANSACTION_DATES_FILLED = 'TRANSACTION_DATES_FILLED';

export const WORKFLOW_SIGNAL_MAIN_ENTRIES_ORDERED_BY_DATE = 'MAIN_ENTRIES_ORDERED_BY_DATE';

export const WORKFLOW_SIGNAL_MAIN_ENTRIES_DATED_AND_ORDERED = 'MAIN_ENTRIES_DATED_AND_ORDERED';

export const WORKFLOW_SIGNAL_MAIN_TRANSACTION_PATH_LABELS_ASSIGNED = 'MAIN_TRANSACTION_PATH_LABELS_ASSIGNED';

export const WORKFLOW_SIGNAL_RAW_DATA_LOADED = 'WAYFINDER_RAW_FETCH_SAVED';

export const WORKFLOW_SIGNAL_TOOL_68_MAIN_DATA_PREPARED = 'TOOL_68_MAIN_DATA_PREPARED';

export const WORKFLOW_SIGNAL_TO_ADDRESS_ATTRIBUTION_APPLIED = 'TO_ADDRESS_ATTRIBUTION_APPLIED';

export const WORKFLOW_SIGNAL_PATH_OPERATION_RESOLVED = 'PATH_OPERATION_RESOLVED';

export const WORKFLOW_SIGNAL_ADDRESS_FLOW_COLORS_APPLIED = 'ADDRESS_FLOW_COLORS_APPLIED';

export const WORKFLOW_SIGNAL_DEPOSIT_HOT_WALLET_NOTES_NORMALIZED = 'DEPOSIT_HOT_WALLET_NOTES_NORMALIZED';

export const WORKFLOW_SIGNAL_DEPOSIT_PATTERNS_REVIEWED = 'DEPOSIT_PATTERNS_REVIEWED';

export const WORKFLOW_SIGNAL_NEW_ENTITIES_REVIEWED = 'NEW_ENTITIES_REVIEWED';

export const CASE_ENTITY_CURATOR_OVERLAY_STORAGE_KEY = 'case_buddy_known_entity_curator_overlay_v1';

export const CASE_ENTITY_CURATOR_REMOTE_EXCHANGE_ENDPOINT = '/api/etherscan/keywords.php';

export const CASE_ENTITY_CURATOR_REMOTE_NON_EXCHANGE_ENDPOINT = '/api/etherscan/keywordsother.php';

export const CASE_ENTITY_REVIEW_STATUS_NEW = 'new_candidate';

export const CASE_ENTITY_REVIEW_STATUS_KNOWN = 'known_match';

export const CASE_ENTITY_REVIEW_STATUS_SUPPRESSED = 'suppressed';

export const CASE_ENTITY_KIND_EXCHANGE = 'exchange';

export const CASE_ENTITY_KIND_NON_EXCHANGE = 'non_exchange';

export const CASE_ENTITY_KIND_UNKNOWN = 'unknown';

export const CASE_DEPOSIT_PATTERN_REVIEW_FAMILY = 'deposit_pattern_review';

export const CASE_DEPOSIT_PATTERN_REVIEW_STATUS_REVIEWED = 'reviewed';

export const CASE_DEPOSIT_PATTERN_REVIEW_STATUS_DISMISSED = 'dismissed';

export const CASE_KNOWN_ENTITY_CASING_REVIEW_FAMILY = 'known_entity_note_casing_review';

export const CASE_KNOWN_ENTITY_CASING_REVIEW_STATUS_REVIEWED = 'reviewed';

export const CASE_KNOWN_ENTITY_CASING_REVIEW_STATUS_DISMISSED = 'dismissed';

export const CASE_KNOWN_ENTITY_CASING_REVIEW_STATUS_APPLIED = 'applied';

export const WORKFLOW_SIGNAL_KNOWN_ENTITY_CASING_REVIEWED = 'KNOWN_ENTITY_CASING_REVIEWED';

export const WORKFLOW_SIGNAL_DUPLICATE_HASHES_LABELED = 'DUPLICATE_HASHES_LABELED';

export const WORKFLOW_SIGNAL_NOTE_HASH_PATH_LABEL_REWRITE_COMPLETE = 'NOTES_BACKUP_AND_HASH_LABELS_REWRITTEN';

export const WORKFLOW_SIGNAL_ADDRESS_LEGEND_REVIEWED = 'ADDRESS_LEGEND_REVIEWED';

export const WORKFLOW_SIGNAL_WWW_USD_REFERENCES_REVIEWED = 'WWW_USD_REFERENCES_REVIEWED';

export const WORKFLOW_SIGNAL_TEMPLATE_DELIVERABLE_REVIEWED = 'TEMPLATE_DELIVERABLE_REVIEWED';

export const WORKFLOW_SIGNAL_SUSPICIOUS_ADDRESS_TABLE_REVIEWED = 'SUSPICIOUS_ADDRESS_TABLE_REVIEWED';

export const WORKFLOW_SIGNAL_EXCHANGE_ADDRESS_TABLE_REVIEWED = 'EXCHANGE_ADDRESS_TABLE_REVIEWED';

export const WORKFLOW_SIGNAL_DORMANT_ADDRESS_DELIVERABLES_REVIEWED = 'DORMANT_ADDRESS_DELIVERABLES_REVIEWED';

export const WORKFLOW_SIGNAL_WHAT_WENT_WHERE_REVIEWED = 'WHAT_WENT_WHERE_REVIEWED';

export const WORKFLOW_SIGNAL_REPORT_BODY_REVIEWED = 'REPORT_BODY_REVIEWED';

export const WORKFLOW_SIGNAL_PATH_ENDING_ROWS_REVIEWED = 'PATH_ENDING_ROWS_REVIEWED';

export const WORKFLOW_SIGNAL_ADDENDUM_RECIPIENTS_RESOLVED = 'ADDENDUM_RECIPIENTS_RESOLVED';

export const WORKFLOW_SIGNAL_ADDENDUM_REVIEWED = 'ADDENDUM_REVIEWED';

export const WORKFLOW_SIGNAL_CASE_FLOW_VISUALS_CREATED = 'CASE_FLOW_VISUALS_CREATED';

export const WORKFLOW_SIGNAL_FULL_REPORT_PACKAGE_REVIEWED = 'FULL_REPORT_PACKAGE_REVIEWED';

export const CASE_DUPLICATE_HASH_LABELER_FAMILY = 'duplicate_hash_labeler';

export const CASE_NOTE_HASH_LABEL_REWRITE_FAMILY = 'note_hash_to_path_label_rewrite';

export const CASE_NOTE_HASH_LABEL_REWRITE_SECTION_REGEX_SOURCE = String.raw`\b(Continues as|Branches as)\b\s*[:-]?\s*([^;\n\r)}\]]*?)(\.(?=\s|$)|[;\n\r)}\]]|$)`;

export const CASE_DEPOSIT_PATTERN_ALLOW_VERY_HIGH_UPGRADE_FROM_MEDIUM = false;

export const CASE_DEPOSIT_PATTERN_THRESHOLDS = Object.freeze({
  highMinutes: 15,
  mediumHours: 4,
  lowHours: 24,
  veryLowHours: 72,
  exactSimilarity: 0.999999,
  lowSimilarity: 0.99,
  veryLowSimilarity: 0.97
});

export const CASE_ENTITY_LOCAL_SUPPRESSED_TERMS = Object.freeze([
  'elevated microbursts',
  'high stablecoin flow-through',
  "Funds leave the victim's Crypto",
  'TransitSwap',
  'significant total TRC20 transfer count',
  'Potential service/hot wallet-like behavior',
  'persistently operational activity',
  'high unique counterparties',
  "com address into the suspect's address",
  "com address and move into the suspect's address",
  'The funds are bridged using TransitSwap',
  'unknown_hot_wallet',
  'unknown',
  'included',
  'me',
  'n',
  'exchange',
  'bot',
  'Deposit Address Pattern',
  'uniswap',
  "victim's crypto",
  'n/a',
  'na',
  'none'
]);

export const WORKFLOW_SIGNAL_CASE_CONCLUSION_REVIEWED = 'CASE_CONCLUSION_REVIEWED';
